module.exports = __webpack_public_path__ + "assets/img/about-head.60ee2909.png";